























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/VSelect.vue";
import { ScoutingArea, ScoutingPlace } from "@/models";
import VCheckbox from "@/components/VCheckbox.vue";
import GroupCard from "@/components/Analysis/GroupCard.vue";
import ScoutingGroup, { ScoutingGroupCreateDTO } from "@/models/ScoutingGroup";
import { ScoutingAnalysis } from "@/models/Scouting";

@Component({
  components: {
    VSelect,
    VCheckbox,
    GroupCard,
  },
})
export default class GroupSidebar extends Vue {
  @Prop() private readonly scoutingAreas!: ScoutingArea[];
  @Prop() private readonly scoutingPlaces!: ScoutingPlace[];
  @Prop() private readonly scoutingGroup?: ScoutingGroup;
  @Prop() private readonly method!: "create" | "update";
  @Prop() private readonly analysis!: ScoutingAnalysis | null;

  groupName = "";
  groupType: "area" | "place" | null = null;
  selectedElements: string[] = [];
  errors: { name: boolean } = { name: false };

  mounted() {
    this.loadSelectedElements();
  }

  @Watch("analysis")
  onAnalysisChanged() {
    if (this.analysis?.scouting.scoutingAreas.length) {
      this.groupType = "area";
    } else if (this.analysis?.scouting.scoutingPlaces.length) {
      this.groupType = "place";
    }

    this.loadSelectedElements();
  }

  get isCreate() {
    return this.method === "create";
  }

  get isUpdate() {
    return this.method === "update";
  }

  loadSelectedElements() {
    if (this.isUpdate && this.scoutingGroup) {
      this.groupName = this.scoutingGroup.name;
      this.groupType = this.scoutingGroup.groupType;

      if (this.groupType === "area") {
        this.selectedElements = this.scoutingGroup.scoutingAreas.map(
          (e) => e.id
        );
      }

      if (this.groupType === "place") {
        this.selectedElements = this.scoutingGroup.scoutingPlaces.map(
          (e) => e.id
        );
      }
    } else {
      this.selectedElements = [];
    }
  }

  onSelectionChange(id: string) {
    const index = this.selectedElements.findIndex((e) => e === id);

    if (index === -1) {
      this.selectedElements.push(id);
      this.$emit("element-add", { id, groupType: this.groupType });
    } else {
      this.selectedElements.splice(index, 1);
      this.$emit("element-remove", { id, groupType: this.groupType });
    }
  }

  buildPayload() {
    if (!this.groupType) {
      return;
    }

    const payload: ScoutingGroupCreateDTO = {
      name: this.groupName,
      groupType: this.groupType,
    };

    if (this.groupType === "area") {
      payload["scoutingAreaIds"] = this.selectedElements;
    } else {
      payload["scoutingPlaceIds"] = this.selectedElements;
    }

    return payload;
  }

  get selectedElementsCount() {
    return this.selectedElements.length;
  }

  get selectedElementsInfo() {
    let groupText = "";
    let selectionText = "";
    if (this.groupType === "area" && this.selectedElementsCount === 1) {
      groupText = "area";
      selectionText = "selezionata";
    } else if (this.groupType === "area" && this.selectedElementsCount !== 1) {
      groupText = "aree";
      selectionText = "selezionate";
    } else if (this.groupType === "place" && this.selectedElementsCount === 1) {
      groupText = "POI";
      selectionText = "selezionato";
    } else if (this.groupType === "place" && this.selectedElementsCount !== 1) {
      groupText = "POI";
      selectionText = "selezionati";
    }

    return `${this.selectedElementsCount} ${groupText} ${selectionText}`;
  }

  onCancelClick() {
    this.$emit("cancel");
  }

  onConfirmClick() {
    if (!this.groupName) {
      this.errors.name = true;
      return;
    }
    this.errors.name = false;
    this.$emit("confirm", this.buildPayload());
  }

  isItemSelected(id: string) {
    return this.selectedElements.includes(id);
  }

  get isLoading() {
    return !this.analysis;
  }
}
